<script setup lang="ts">
import FooterColumns from '~/components/ui/FooterColumns.vue'

const links = [
  {
    label: 'Unit Organisasi',
    children: [
      { label: 'BPSDM Pertahanan', to: '/bpsdm-pertahanan' },
      { label: 'Personel', to: '/personel' },
      { label: 'Diklat', to: '/diklat' },
      { label: 'Berita', to: '/berita' },
      { label: 'Kontak', to: '/kontak' }
    ]
  },
  {
    label: 'Pusdiklat',
    children: [
      { label: 'Pusdiklat Jemenhan', to: '/pusdiklat/jemenhan' },
      { label: 'Pusdiklat Bahasa', to: '/pusdiklat/bahasa' },
      { label: 'Pusdiklat Tekfunghan', to: '/pusdiklat/tekfunghan' },
      { label: 'Pusdiklat Bela Negara', to: '/pusdiklat/bela-negara' }
    ]
  },
  {
    label: 'Tautan',
    children: [
      { label: 'Kemhan RI', to: 'https://www.kemhan.go.id' },
      { label: 'Mabes TNI', to: 'https://tni.mil.id/home' },
      { label: 'TNI AD', to: 'https://tniad.mil.id' },
      { label: 'TNI AL', to: 'https://www.tnial.mil.id' },
      { label: 'TNI AU', to: 'https://tni-au.mil.id/' }
    ]
  }
]

const iconLinks = [
  {
    label: 'Facebook',
    icon: 'i-simple-icons-facebook',
    to: 'https://www.facebook.com/KementerianPertahananRI'
  },
  {
    label: 'Instagram',
    icon: 'i-simple-icons-instagram',
    to: 'https://www.instagram.com/kemhanri'
  },
  {
    label: 'Youtube',
    icon: 'i-simple-icons-youtube',
    to: 'https://www.youtube.com/@BadiklatKemhanRI'
  },
  {
    label: 'TikTok',
    icon: 'i-simple-icons-tiktok',
    to: 'https://www.tiktok.com/@badiklatkemhanri'
  }
]

const config = computed(() => ({
  label: 'text-sm/6 font-semibold text-gray-900 dark:text-white'
}))
</script>

<template>
  <UFooter>
    <template #top>
      <FooterColumns :links="links">
        <template #left>
          <div>
            <NuxtImg
              src="/assets/logo-oneklik-bpsdm.png"
              alt="logo-oneklik-bpsdm"
              class="max-h-14"
            />

            <div class="mt-10 font-light">
              Ada pertanyaan? Hubungi kami <br />Senin - Jumat pukul 08.00 - 16.30
            </div>
            <div class="mt-5 font-light">Jl. Menteng Raya 56<br />Jakarta Pusat<br />Indonesia</div>

            <div class="mt-5 font-bold">(021) - 3107730/32</div>

            <UButton
              label="Kontak Kami"
              color="primary"
              size="sm"
              class="mt-6"
              to="/kontak"
              trailing-icon="i-heroicons-arrow-right-20-solid"
            />
          </div>
        </template>

        <template #right>
          <h3 :class="config.label">Sosial Media Kami</h3>

          <div class="mt-6 flex space-x-4">
            <ULink
              v-for="(link, index) of iconLinks"
              :key="index"
              :to="link.to"
              :class="config.label"
            >
              <UIcon
                :name="link.icon"
                class="h-6 w-6 text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
              />
            </ULink>
          </div>
        </template>
      </FooterColumns>
    </template>

    <template #left>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Copyright © {{ new Date().getFullYear() }}. All rights reserved.
      </p>
    </template>

    <template #right>
      <ULink
        class="text-sm text-gray-500 dark:text-gray-400"
        to="/term-condition"
      >
        Term & Kondisi
      </ULink>
    </template>
  </UFooter>
</template>
